
  export const itemCodeEventsRoutes = {
    codeevent: '/admin/code-events/:itemIdd',
    getCodeEventsLink: (itemId: string) => `/admin/code-events/${itemId}`,
  };
  